module.exports = __webpack_public_path__ + "img/dental-office-tour-lobby1.03c339a4.jpeg";